export const activityGoods = {
  clickSearch: '2010.0', // 特惠活动页点击搜索框
  clickClassify: '2011.0', // 特惠活动页点击分类
  sortPrice: '2012.0', // 特惠活动页点击价格排序
  clickFilter: '2013.0', // 特惠活动页点击筛选
  plusCar: 'n.5256.11095.0', // 推荐商品普通加购
  minusCar: 'n.5256.11096.0', // 推荐商品普通减购
  chooseFormate: 'n.5256.11094.0', // 推荐商品选规格
  plusCarModal: 'n.5256.11097.0', // 推荐商品规格弹窗加购
  minusCarModal: 'n.5256.11098.0', // 推荐商品规格弹窗减购
  goDetail: 'n.5256.11093.0', // 推荐商品点击
  goodExpose: 'n.5256.11093.0' // 推荐商品曝光
}
